import { BaseApiService } from "../../base-api-service";
import { ApiVersions } from "../../../enums";
import { env } from "../../../environment";
import { Game } from "../../../models";
import {
  GameResponse,
  betShopRequest,
  betShopsResponse,
  BetShopsResponse,
  GamesControlRequest,
  GamesControlResponse,
  gamesOfBetshopsRequest, GamesOfBetshopsResponse,
} from "../../../models/api/games-control";

class GamesControlController extends BaseApiService {
  public async getGameList(
    params?: GamesControlRequest,
  ): Promise<GamesControlResponse> {
    const url = `${this.url}/api/${ApiVersions.V1}/game`;
    return await this.http.get(url, { params });
  }

  public async getGameById(id: number): Promise<Game> {
    const url = `${this.url}/api/${ApiVersions.V1}/game/${id}`;
    return await this.http.get(url);
  }

  public async updateGroupType(gameId: number, type: number): Promise<any> {
    const url = `${this.url}/api/${ApiVersions.V1}/game/${gameId}`;
    return await this.http.put(url, { type });
  }

  public async updateBetShops(
    data: betShopsResponse,
  ): Promise<BetShopsResponse> {
    const url = `${this.url}/api/${ApiVersions.V1}/betshopGame`;
    return await this.http.post(url, data);
  }

  public async syncGames(partnerId: number): Promise<void> {
    const url = `${this.url}/api/${ApiVersions.V1}/game/${partnerId}`;
    return await this.http.post(url);
  }

  public async getBetShopsGames(params: betShopRequest): Promise<GameResponse> {
    const url = `${this.url}/api/${ApiVersions.V1}/betshopGame`;
    return await this.http.get(url, { params });
  }

  public async getGamesOfBetshops(params: gamesOfBetshopsRequest): Promise<GamesOfBetshopsResponse> {
    const url = `${this.url}/api/${ApiVersions.V1}/betshopGame/betshop-games`;
    return await this.http.get(url, { params });
  }

  public async getBetShops(params: betShopRequest): Promise<BetShopsResponse> {
    const url = `${this.url}/api/${ApiVersions.V1}/betshopGame/betshops`;
    return await this.http.get(url, { params });
  }
}

export const gamesControlController = new GamesControlController({
  url: env.httpUrl,
});
